import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { AppService } from '../../../app.service';
import { Department, WorkArea } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { AddDepartmentDialogComponent } from './add-department-dialog/add-department-dialog.component';
import { AddWorkareaDialogComponent } from './add-workarea-dialog/add-workarea-dialog.component';
import { EditSetupDepComponent } from './edit-setup-dep/edit-setup-dep.component';
import { EditWorkareaDialogComponent } from './edit-workarea-dialog/edit-workarea-dialog.component';

@Component({
  selector: 'app-config-setup-department',
  templateUrl: './config-setup-department.component.html',
  styleUrls: ['./config-setup-department.component.css']
})
export class ConfigSetupDepartmentComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private _appService: AppService,
    private _safetyConfigService:SafetyConfigService,
  ) { }

  departmentlist:Department[]=[];
  worklist:WorkArea[]=[];
  ngOnInit() {
   
    this.getdepartmentlist();
    this._appService.setPageTitle('Setup Departments');
  }



getdepartmentlist(){
  this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
  
  this.departmentlist=res.Departments;
  this.worklist=res.WorkAreas;
  console.log( "departments",this.departmentlist)
  console.log( "workareas", this.worklist)
  })
}
OpenEditDepDialog(CatInf:Department){
  const dialogRef = this.dialog.open(EditSetupDepComponent, { 
    disableClose: true,
    data:{
      catId:CatInf.ID
    }

    });

   
    

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){

    console.log('The dialog was closed');
    this.getdepartmentlist();
   }
 });
 
}
//EditWorkareaDialogComponent
OpenEditWorkArea(CatInf:WorkArea){
  const dialogRef = this.dialog.open(EditWorkareaDialogComponent, { 
    disableClose: true,
    data:{
      catId:CatInf.ID,
      DepartmentID:CatInf.DepartmentID,
      active:CatInf.Active
    }

    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){
    this.getdepartmentlist();

    console.log('The dialog was closed');
   }
 });
}

//AddWorkareaDialogComponent
openAddwork(CatInf:WorkArea){
  const dialogRef = this.dialog.open(AddWorkareaDialogComponent, { 
    disableClose: true,
    data:{
      catId:CatInf.ID
    }

    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){
    this.getdepartmentlist();

    console.log('The dialog was closed');
   }
 });
}

//AddDepartmentDialogComponent
openAddDepartmentDialog(){
  const dialogRef = this.dialog.open(AddDepartmentDialogComponent, { 
    disableClose: true,
    data:{

    }

    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){
    this.getdepartmentlist();

    console.log('The dialog was closed');
   }
 });
}


ChangeActive(qus){
  let params = new WorkArea ();

    params.ID = qus.ID;
    params.WorkAreaName = qus.WorkAreaName;
    params.DepartmentID = qus.DepartmentID
    params.Active=!qus.Active;
    params.WorkAreaDescription=qus.WorkAreaDescription;
    params.SiteId=qus.SiteId;
    
    

    //create new category
    this._safetyConfigService.UpdateWorkArea(params).subscribe(res => {
     
      if (res.m_Item1) {
        this.getdepartmentlist()
      }
      // this.dialogRef.close();

    })
}

}
